import { ReducedMotionProvider } from "@/lib/motion";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import type { ReactNode } from "react";
import { Toaster } from "@/components/ui/sonner";
import { configureBoneyard } from "@/components/ui/bone";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Boneyard skeleton defaults — tuned to the pink/muted palette so bones blend
// with the rest of the UI in both light and dark modes.
configureBoneyard({
  color: "rgba(0,0,0,0.08)",
  darkColor: "rgba(255,255,255,0.06)",
  animate: "shimmer",
  stagger: 40,
  transition: 220,
});

export function Providers({ children }: { children: ReactNode }): ReactNode {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider
        attribute="class"
        defaultTheme="dark"
        enableSystem
        disableTransitionOnChange
      >
        <ReducedMotionProvider>
          <TooltipProvider>
            {children}
            <Toaster position="bottom-right" />
          </TooltipProvider>
        </ReducedMotionProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
